import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 44px;
`;

export const Header = styled.div`
  display: flex;
  gap: 22px;
  align-items: flex-start;
  padding-bottom: 28px;
  border-bottom: 1px solid #d6d6d6;
`;

export const HeaderIcon = styled.div<{ accent: string }>`
  color: ${({ accent }) => accent};

  svg {
    width: 36px;
    height: 36px;
  }
`;

export const HeaderText = styled.div`
  h1 {
    font-size: 24px;
    line-height: 33px;
    font-weight: 700;
    color: #231d19;
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    color: #000;
    max-width: 620px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 40px;
  padding-top: 32px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const RightColumn = styled.div`
  width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const IllustrationImageWrapper = styled.div`
  width: 100%;
  max-width: 349px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionTitle = styled.h2`
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: #000;
  margin-bottom: 24px;
`;

export const SummaryBox = styled.div<{
  backgroundColor: string;
  borderColor: string;
}>`
  display: flex;
  align-items: center;
  min-height: 50px;
  background: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-left-width: 4px;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  color: #202020;
  margin-bottom: 28px;
  width: fit-content;
`;

export const Hint = styled.div<{ accent: string }>`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;

  svg {
    width: 22px;
    height: 22px;
    color: ${({ accent }) => accent};
    flex-shrink: 0;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    color: #231d19;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: auto;

  > div {
    width: auto;
  }

  > div > button {
    width: auto;
    min-width: 212px;
    padding: 0 24px;
  }
`;
